import store, { RootState } from '../store/store';
import { setActiveChatGroup } from '../store/slices/chatHistorySlice';

class ChatNavigationService {
  private static instance: ChatNavigationService;
  
  private constructor() {
    // Initialize URL handling
    window.addEventListener('popstate', this.handlePopState.bind(this));
  }

  static getInstance(): ChatNavigationService {
    if (!this.instance) {
      this.instance = new ChatNavigationService();
    }
    return this.instance;
  }

  // Update URL without breaking WebSocket state
  updateURL(chatId: string | null) {
    if (chatId) {
      window.history.pushState(
        { chatId },
        '',
        `/chat/${chatId}`  // Using path-based routing
      );
    } else {
      window.history.pushState(
        {},
        '',
        window.location.pathname
      );
    }
  }

  // Handle browser back/forward
  private handlePopState(event: PopStateEvent) {
    const chatId = event.state?.chatId;
    store.dispatch(setActiveChatGroup(chatId || null));
  }

  // Get chat ID from URL
  getChatIdFromURL(): string | null {
    const path = window.location.pathname;
    if (path.startsWith('/chat/')) {
      return path.replace('/chat/', '');
    }
    return null;
  }
}

export default ChatNavigationService; 